import React, { Component } from 'react';
import { Col, Row } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, LabelList } from 'recharts';
import CustomTooltip from "../../external/dashboard/usage-chart/custom-tooltip.component";
import './bar-graph.component.css';
import { CustomContent, CustomTooltipWhite, SingleBarToolTip, WrappedXAxis } from './utilities'
import { Text } from 'recharts';
import Translation from "../../common/translation/translation.component";
export class LegendComp extends Component { 
  
  render() {
    return (
      <Row className="legend-cont" >
          <Col xs={10} md={6} lg={6} className="legend-details" >
              {this.props.data!==undefined ?
                    (this.props.data).map((key, i) => {
                      const prefix = key.dataKey !== undefined ? key.dataKey : key.name.toLowerCase().replaceAll(' ', '');
                      const classNames =  `${prefix}-bg-color cicle-tr-curr`;
                      return (
                          <div className="legend-value" key={i} >
                              {key.color !== undefined ? <span className={classNames}></span> : ""}                         
                              {' ' + key.name}
                          </div>
                      )
                  }) :
                  ""
              }                  
          </Col>  
      </Row>
  )
  }
}

export class BarGraph extends Component {

  render() {
    return (
      <div> 
        <ResponsiveContainer width="100%" height={350} marginTop='10'> 
          <BarChart width={730} data={this.props.data} reverseStackOrder={true}>
            <XAxis axisLine={false} tickLine={false} dataKey="Month" tick={{fontSize: 13, fill: '#919eab'}} /> 
            <YAxis hide={true} width={20} tickLine={false} axisLine={false} tick={{fontSize: 13, fill: '#919eab'}} paddingBottom={20}/>
            <Tooltip content={<CustomTooltip/>}/>
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" vertical={false}/>    
            {(this.props.barData).map((v, i) => {
                return <Bar key={i} dataKey={v.name} fill={v.color} barSize={15} radius={20} unit={this.props.currencySymbol} />
            })}        
          </BarChart>
        </ResponsiveContainer>
        {this.props.graphFooter!==undefined ?
          <div className="graph-footer">
            {this.props.graphFooter.map((item, id) =>
                <h1 key={id} className="line-graph-footer">{item.Year}</h1>
            )}
          </div> : "" }
      </div>
    ) 
  }
}


export class SingleBarGraph extends Component {
    CustomXAxisTick = ({ x, y, payload }: any) => {
        if (payload && payload.value) {
            return (
                <Text
                    fontSize={"12px"}
                    width={90}
                    x={x}
                    y={y}
                    textAnchor="middle"
                    verticalAnchor="start"
                >{payload.value}</Text>
            );
        }
        return null;
    };

  render() {
      return (                
            <div className="graph-container">
              {this.props.data.length > 0 ?
                      <ResponsiveContainer width="100%" height={500}>
                          <BarChart margin={{ top: 20, right: 30, left: 20, bottom: 40 }} width={500} data={this.props.data}>
                              <Tooltip content={<SingleBarToolTip />} />
                              <CartesianGrid strokeDasharray="3 3" vertical={false} />
                              <XAxis tick={this.CustomXAxisTick} dataKey="ChargeType" interval={0} fontFamily="Graphik Semibold" color='#15181b' fontSize={12} fontWeight='normal'/>
                              <YAxis />
                              <Bar dataKey="GrossAmount" fill="#008eff" radius={[10, 10, 0, 0]} />                               
                          </BarChart>
                      </ResponsiveContainer>
                  :                 
                  <div className="subline-overview-container">
                      <div className="no-data-message">
                          <h4 className="table-no-results"><Translation translationKey="no_data_retrieved_subline" /></h4>
                      </div>
                  </div>}
             </div>);
  }
}


export class StackedBarChart extends Component {

  render() { 
    return (
      <div className="graph-container"> 
        <ResponsiveContainer width="100%" height={300} marginTop='10'> 
          <BarChart width={500} height={300} data={this.props.data}>
            <XAxis axisLine={false} tickLine={false} dataKey="name" fontFamily="Graphik Semibold" color='#15181b' fontSize={12} fontWeight='normal'/> 
            <YAxis width={35} tickLine={false} axisLine={false} tick={{fontSize: 12, fill: '#15181b'}} paddingBottom={20} fontFamily="Graphik-Regular"
              tickFormatter={this.props.tickFormat !== undefined ? this.props.tickFormat : ""} 
              domain={this.props.domainFormat !== undefined ? this.props.domainFormat : [0, 'auto']} />
            <Tooltip content={<CustomTooltipWhite />} />
            <CartesianGrid strokeDasharray="3 3" vertical={false}/>    
            {(this.props.barData).map((v, i, {length}) => {
              const key = v.dataKey !== undefined ? v.dataKey : v.name;
              if ( i + 1 === length) {
                return <Bar key={i} dataKey={key} name={v.name} stackId="a" fill={v.color} barSize={70} radius={[10, 10, 0, 0]}/>
              } else 
                return <Bar key={i} dataKey={key} name={v.name} stackId="a" fill={v.color} barSize={70} />
            })}        
          </BarChart>
        </ResponsiveContainer>  
        {this.props.graphFooter!==undefined ?
          <div className="graph-footer">
            <h1 className="bar-graph-footer">{this.props.graphFooter}</h1>
          </div> :  ""
        }
      </div>
    ) 
  }
}

export class BarGraphWithLabel extends Component {

  render() { 
    return (
      <div className="graph-container"> 
        <ResponsiveContainer width="100%" height={300} marginTop='10'> 
          <BarChart width={730} data={this.props.data}>
            <XAxis axisLine={false} tickLine={false} dataKey="name" fontFamily="Graphik Semibold" color='#15181b' fontSize={12} fontWeight='normal'/> 
            <YAxis width={20} tickLine={false} axisLine={false} tick={{fontSize: 12, fill: '#919eab'}} paddingBottom={20}/>
            <Tooltip content={<CustomTooltipWhite />} />
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" vertical={false}/>    
            {(this.props.barData).map((v, i) => {
              const key = v.dataKey !== undefined ? v.dataKey : v.name;
              return (
                <Bar key={i} dataKey={key} name={v.name} fill={v.color} barSize={15} radius={20}> 
                  <LabelList key={i}  dataKey={key} position='top' fontSize={10} fontFamily="Graphik-Regular" />
                </Bar>
              )

            })}        
          </BarChart>
        </ResponsiveContainer>
        {this.props.graphFooter !== undefined ?
          <div className="graph-footer">
            <h1 className="bar-graph-footer">{this.props.graphFooter}</h1>
          </div> :
        ""
        }
      </div>
    ) 
  }
}

export class HorizontalBarGraph extends Component {
  render() { 
    const withMargin50 = this.props.withMargin ? "margin-right50" : "";

    return (
      <div className={"graph-container " + withMargin50}> 
        <ResponsiveContainer width="100%" height={400} marginTop='10'> 
          <BarChart width={700} data={this.props.data} layout="vertical">
            <XAxis axisLine={false} tickLine={false} type="number" color='#15181b' fontSize={12} fontWeight='normal'/> 
            <YAxis width={100} tickLine={false} dataKey="name" type="category" fontFamily="Graphik-Regular" fontWeight="normal" axisLine={false} tick={{fontSize: 12, fill: '#919eab'}} paddingBottom={20}/>
            <Tooltip /*wrapperStyle={{top:-70, left:50}}*/ content={<CustomContent />} />
            <CartesianGrid horizontal={false}/>    
            <Bar dataKey="value" fill={this.props.fill} barSize={50} radius={[0, 10, 10, 0]} />          
          </BarChart> 
        </ResponsiveContainer>
        {this.props.graphFooter !== undefined ?
          <div className="graph-footer">
            <h1 className="bar-graph-footer">{this.props.graphFooter}</h1>
          </div> :
        ""
        }
      </div>
    ) 
  }
}

